import * as THREE from 'three';
import { Vector3 } from 'three';
import TWEEN from '@tweenjs/tween.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import BaseMesh from './base-mesh';
class Car3d extends BaseMesh {
    props;
    skeleton;
    isLoaded;
    currentVector3;
    disposeStatus;
    static gltf;
    static model;
    model;
    tween;
    preAngle = 0;
    carWidth; // 车宽
    carLength; // 车长
    direction;
    constructor(data) {
        super(data);
        this.props = data;
        const { position } = data;
        const { vertices, direction } = data.renderProps;
        this.position.set(position.x, position.y, position.z);
        this.direction = direction;
        this.tween = new TWEEN.Tween({
            x1: this.position.x,
            y1: this.position.y,
            z1: this.position.z,
        });
        const loader = new GLTFLoader();
        this.isLoaded = false;
        this.disposeStatus = false;
        this.currentVector3 = new Vector3(1, 0, 0);
        loader.load('/Mod_Car-0926.gltf', (gltf) => {
            Car3d.model = gltf.scene.getObjectByName('Mod_Car');
            this.model = Car3d.model;
            // 阴影相关
            this.model.traverse((object) => {
                if (object.isMesh) {
                    // object.castShadow = true;
                    // object.material.translate = true;
                    // ((object as Mesh).material as MeshToonMaterial).color.set('black');
                    object.material.transparent = true;
                    object.material.depthTest = true;
                    object.material.emissive.set('black');
                    object.material.opacity = 1;
                }
            });
            // this.model.scale.set(1, 1, 1);
            const box = new THREE.Box3().setFromObject(this.model);
            const size = box.getSize(new THREE.Vector3());
            this.carWidth = size.z;
            this.carLength = size.x;
            this.updateCarAngle(direction);
            this.scaleModel(vertices);
            this.add(this.model);
            this.isLoaded = true;
        });
    }
    update(data) {
        const { position } = data;
        const { direction } = data.renderProps;
        if (!this.isLoaded) {
            this.position.set(position.x, position.y, position.z);
        }
        else {
            this.updateCarAngle(direction);
        }
    }
    updateCarAngle(direction) {
        if (this.preAngle)
            this.rotateY(-this.preAngle);
        const _position = new THREE.Vector3(direction.x, direction.y, direction.z);
        if (_position.length() === 0)
            return;
        const normalVector = new THREE.Vector3();
        normalVector.crossVectors(this.currentVector3, _position); // 坐标平面法线
        const isReverse = normalVector.y > 0;
        const angle = this.currentVector3.angleTo(_position);
        this.rotateY(isReverse ? angle : -angle);
        this.preAngle = isReverse ? angle : -angle;
    }
    scaleModel(vertices) {
        let max = Number.MIN_SAFE_INTEGER;
        let min = Number.MAX_SAFE_INTEGER;
        const points = [];
        vertices.forEach((e) => {
            const { x, y, z } = e;
            points.push(new THREE.Vector3(x, y, z));
        });
        for (let i = 1; i < points.length; i++) {
            const len = points[i - 1].distanceTo(points[i]);
            max = Math.max(max, len);
            min = Math.min(min, len);
        }
        const widthScale = (min * 0.9) / this.carWidth;
        const lengthScale = (max * 0.9) / this.carLength;
        const scale = Math.min(widthScale, lengthScale);
        this.model?.scale.set(scale, scale, scale);
    }
    dispose() {
        new TWEEN.Tween({
            opacity: 1,
        })
            .to({
            opacity: 0,
        }, 1000)
            .onUpdate((obj) => {
            this.model?.traverse((object) => {
                if (object.isMesh) {
                    object.material.opacity = obj.opacity;
                }
            });
        })
            .onComplete(() => {
            const { onDestory } = this.props;
            this.model = undefined;
            this.disposeStatus = true;
            this.traverse(function (obj) {
                if (obj instanceof THREE.Mesh) {
                    obj.geometry.dispose();
                    obj.material.dispose();
                }
                else {
                    if (obj.parent) {
                        obj?.parent.remove(obj);
                    }
                    obj.clear();
                }
            });
            this.parent?.remove(this);
            this.clear();
            if (onDestory && typeof onDestory === 'function') {
                onDestory(this);
            }
        })
            .start();
    }
}
export default Car3d;
